import script from "./AssessmentTranscribe.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentTranscribe.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentTranscribe.vue?vue&type=style&index=0&id=21d4ed8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d4ed8a"]])

export default __exports__